import AnimationMnager from '../module/animation';
import effectManager from '../module/effect';
import Util from '../module/libs/util';
import bgManager from './bg';

const animation = new AnimationMnager();
const effect=new effectManager();
const util = new Util();

export default class reuseManager {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.bg = new bgManager();

        this.$root =  $("#l-root,#l-scroll");
        this.$kv =  $("#p-kv");
        this.$kvCopy = $(".js__text-copy");

        this.$result = $("#p-kv-result");
        this.$scroll = $("#c-scrolldown");
        this.$share = $("#c-share");

        /* 低スペック端末用の分岐 */
        this.type = Useragnt.ie||Useragnt.tablet ? "low" : "normal";

    }
    splash(){

        let _this = this;

        TweenMax.set(this.$kv.find('.l-img'),{ opacity:0,scale:1.05} );
        TweenMax.to(this.$kv.find('.l-img'),0.9, {
            opacity:1,
            ease: "Power2.easeInOut",
        });
        TweenMax.to(this.$kv.find('.l-img'),1.0, {
            scale:1,
            ease: "Power2.easeOut",
        });

    }
    init(display,executionType){

        let _this = this;

        //set
        TweenMax.set(this.$scroll,{ y:200 } );
        TweenMax.set([this.$share,this.$result],{ x:300 } );
        effect.splitText(this.$kv.find(".js__split-text"),"set");
        effect.show(this.$kvCopy,"set");

        if(Useragnt.mobile || Useragnt.tablet) {
            $('.js__tsc').eq(0).addClass('is-show');
        }

        effect.show(_this.$kvCopy,"show");
        setTimeout(function () {
            effect.splitText($(".js__split-text.is-splash >* >*"),"show");
            if(Useragnt.mobile || Useragnt.tablet){
                effect.scShowSlow($('.js__tsc-show__slow').eq(0),"show");
            }
        },450);
        setTimeout(function () {
            _this.$share.removeClass('is-color');
            TweenMax.to([_this.$scroll,_this.$share,_this.$result],1.2,{
                x:0,
                y:0,
                ease: "Power2.easeOut",
            });
        },2e3);
        setTimeout(function () {
            if(_this.type!=="low") _this.bg.start(display);
        },5e3);

        $.getJSON("../result.json", function(data) {
            $('#p-kv-result .num').html(data[0]['number']);
        });

    }
    resize(){

        this.w = window.innerWidth;
        this.h = window.innerHeight;

    }
}